import React from "react";

function Close() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      fill="none"
      viewBox="0 0 37 37"
    >
      <g filter="url(#filter0_b_255_1288)">
        <mask
          id="path-1-outside-1_255_1288"
          width="37"
          height="37"
          x="0"
          y="0"
          fill="#000"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M0 0H37V37H0z"></path>
          <path
            fillRule="evenodd"
            d="M36 1H9.5L1 7.5V36h27.5l7.5-7V1zM12.283 12.303a1 1 0 011.414-.02l5.103 4.961 5.103-4.961a1 1 0 111.394 1.434l-5.062 4.922 5.062 4.922a1 1 0 11-1.394 1.434L18.8 20.034l-5.103 4.96a1 1 0 11-1.394-1.433l5.063-4.922-5.063-4.922a1 1 0 01-.02-1.414z"
            clipRule="evenodd"
          ></path>
        </mask>
        <path
          fill="#000"
          fillRule="evenodd"
          d="M36 1H9.5L1 7.5V36h27.5l7.5-7V1zM12.283 12.303a1 1 0 011.414-.02l5.103 4.961 5.103-4.961a1 1 0 111.394 1.434l-5.062 4.922 5.062 4.922a1 1 0 11-1.394 1.434L18.8 20.034l-5.103 4.96a1 1 0 11-1.394-1.433l5.063-4.922-5.063-4.922a1 1 0 01-.02-1.414z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#80FF00"
          d="M9.5 1V.5h-.17l-.134.103L9.5 1zM36 1h.5V.5H36V1zM1 7.5l-.304-.397-.196.15V7.5H1zM1 36H.5v.5H1V36zm27.5 0v.5h.197l.144-.135L28.5 36zm7.5-7l.341.366.159-.149V29H36zM13.697 12.283l-.348.359.348-.359zm-1.414.02l-.358-.349.358.349zm6.517 4.941l-.349.359.349.338.349-.338-.349-.359zm5.103-4.961l.349.359-.349-.359zm1.394 1.434l-.348-.359.348.359zm-5.062 4.922l-.349-.359-.369.359.37.358.348-.358zm5.062 4.922l-.348.358.348-.358zm.02 1.414l-.358-.349.358.349zm-1.414.02l-.349.358.349-.358zM18.8 20.034l.349-.359-.349-.339-.349.34.349.358zm-5.103 4.96l.349.36-.349-.36zm-1.414-.02l.359-.348-.359.349zm.02-1.413l.348.358-.348-.358zm5.063-4.922l.348.358.369-.358-.369-.359-.348.359zm-5.063-4.922l.348-.359-.348.359zM9.5 1.5H36v-1H9.5v1zM1.304 7.897l8.5-6.5-.608-.794-8.5 6.5.608.794zM1.5 18.5v-11h-1v11h1zm0 17.5V18.5h-1V36h1zm27-.5H1v1h27.5v-1zm7.159-6.866l-7.5 7 .682.731 7.5-7-.682-.73zM35.5 28.5v.5h1v-.5h-1zm0-27.5v27.5h1V1h-1zM14.046 11.925a1.5 1.5 0 00-2.121.03l.717.697a.5.5 0 01.707-.01l.697-.717zm5.103 4.96l-5.103-4.96-.697.716 5.102 4.962.698-.717zm4.405-4.96l-5.102 4.96.697.718 5.102-4.962-.697-.716zm2.122.03a1.5 1.5 0 00-2.122-.03l.698.716a.5.5 0 01.707.01l.716-.697zm-.03 2.12a1.5 1.5 0 00.03-2.12l-.717.697a.5.5 0 01-.01.707l.697.716zm-5.063 4.922l5.063-4.921-.697-.718-5.063 4.922.697.717zm5.063 4.205l-5.063-4.922-.697.717 5.063 4.922.697-.717zm.03 2.121a1.5 1.5 0 00-.03-2.12l-.697.716a.5.5 0 01.01.707l.716.697zm-2.122.03a1.5 1.5 0 002.122-.03l-.717-.697a.5.5 0 01-.707.01l-.698.717zm-5.102-4.96l5.102 4.96.698-.717-5.103-4.96-.698.716zm-4.406 4.96l5.103-4.96-.698-.718-5.102 4.961.697.717zm-2.121-.03a1.5 1.5 0 002.12.03l-.696-.717a.5.5 0 01-.707-.01l-.717.697zm.03-2.12a1.5 1.5 0 00-.03 2.12l.717-.697a.5.5 0 01.01-.707l-.698-.717zm5.062-4.923l-5.063 4.922.697.717 5.063-4.922-.697-.717zm-5.063-4.205l5.063 4.922.697-.717-5.062-4.922-.698.717zm-.03-2.12a1.5 1.5 0 00.03 2.12l.697-.716a.5.5 0 01-.01-.707l-.716-.698z"
          mask="url(#path-1-outside-1_255_1288)"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_b_255_1288"
          width="45.453"
          height="45.453"
          x="-4.227"
          y="-4.227"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="2.363"
          ></feGaussianBlur>
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_255_1288"
          ></feComposite>
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_255_1288"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default Close;
